import { render, staticRenderFns } from "./DecoEditor.vue?vue&type=template&id=6f81ee6d&"
import script from "./DecoEditor.vue?vue&type=script&lang=ts&"
export * from "./DecoEditor.vue?vue&type=script&lang=ts&"
import style0 from "./DecoEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports